import React from "react";
import { Link } from "react-router-dom";
import { BrandLogo } from "./Mascot";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen bg-canvas flex flex-col">
      <div className="max-w-md w-full mx-auto px-6 py-8 flex-1 flex flex-col justify-center">
        <Link to="/" className="flex items-center gap-2 mb-8" data-testid="auth-brand">
          <BrandLogo size={40} />
          <span className="font-heading font-black text-xl text-ink">ChoreMouse</span>
        </Link>
        <h1 className="font-heading font-black text-3xl text-ink mb-1">{title}</h1>
        {subtitle && <p className="text-ink-soft font-medium mb-7">{subtitle}</p>}
        {children}
      </div>
      {footer && <div className="pb-8 text-center text-sm font-semibold text-ink-soft">{footer}</div>}
    </div>
  );
}
